var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgDownload = function SvgDownload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.663 18.158c.366 0 .663.297.663.663a2.368 2.368 0 0 0 2.368 2.368h10.611a2.37 2.37 0 0 0 2.369-2.368.663.663 0 0 1 1.326 0 3.695 3.695 0 0 1-3.695 3.695H6.695A3.695 3.695 0 0 1 3 18.82c0-.366.297-.663.663-.663M12.663 2.147a.663.663 0 1 0-1.326 0V14.19L8.679 11.53a.663.663 0 1 0-.938.938l3.79 3.79a.66.66 0 0 0 .951-.015l3.776-3.775a.663.663 0 1 0-.938-.938l-2.657 2.657z",
    clipRule: "evenodd"
  })));
};
export { SvgDownload as ReactComponent };
export default __webpack_public_path__ + "static/media/download.98edd329d4ce1bdbef2e3c218c65cbb7.svg";